import {Action} from '@reduxjs/toolkit'
import {persistReducer} from 'redux-persist'
import storage from 'redux-persist/lib/storage'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes = {
  SetFilter: '[Projects SetFilter] Action',
  ResetFilter: '[Projects ResetFilter] Action',
}

const initialProjectsState: IProjectsState = {
  filter: {
    siteId: '',
    status: '',
    startDate: '',
    endDate: '',
  },
}

export interface IProjectsState {
  filter?: {
    siteId: string
    status: string
    startDate: string
    endDate: string
  }
}

export const reducer = persistReducer(
  {storage, key: 'v100-Projects', whitelist: ['filter']},
  (state: IProjectsState = initialProjectsState, action: ActionWithPayload<IProjectsState>) => {
    switch (action.type) {
      case actionTypes.ResetFilter: {
        return initialProjectsState
      }

      case actionTypes.SetFilter: {
        const filter = action.payload?.filter
        return {...state, filter}
      }

      default:
        return state
    }
  }
)

export const Actions = {
  resetFilter: () => ({type: actionTypes.ResetFilter}),
  setFilter: (filter: object) => ({
    type: actionTypes.SetFilter,
    payload: {filter},
  }),
}

export function* saga() {}
